
import { VueDraggableNext } from 'vue-draggable-next'
import { defineComponent, PropType, ref } from 'vue';
import AddCode from 'components/grouper-common/AddCode.vue';
import { Code } from 'src/contracts/code';
import { CodeType } from 'src/contracts/codeType';
export default defineComponent({
  components: {
    AddCode,
    draggable: VueDraggableNext,
  },
  props: {
    title: String,
    rows: Array<Code>,
    columns: Array<{ name: string }>,
    dragDisallowed: Boolean,
    type: {
      type: Number as PropType<CodeType>,
      required: true,
      default: CodeType.Other,
    },
    collapsible: {
      type: Boolean,
      default: true
    },
    collapseType: {
      type: String,
      default: 'expansion'
    }
  },
  emits: ['reorder', 'dragStart'],
  setup() {
    return {
      text: ref(''),
      open: ref(true),
      description: ref(''),
    }
  }
})
